import * as React from 'react'

import CardTooltip from 'components/common/CardTooltip'
import Popover from 'components/common/Popover'
import Text from 'components/common/Text'
import Tag from 'components/common/Tag'
import theme from 'theme'

const CharacteristicsTags: React.FC<{
  tags: (string | number)[][]
  tooltipContent?: React.ReactNode
  truncateList?: boolean
}> = ({ tags, tooltipContent, truncateList = false }) => {
  return (
    <div
      css={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginLeft: -theme.space[1]
      }}
    >
      {truncateList ? (
        <>
          {tags.slice(0, 2).map(([key, value]) => {
            return <Tag key={`${key}${value}`} tagKey={key} tagValue={value} />
          })}
          <Popover>
            {({ getTargetProps, getPopoverProps }) => (
              <>
                <div
                  {...getTargetProps({
                    css: {
                      background: theme.colors.white[0],
                      minWidth: 20, // height of tags
                      margin: theme.space[1],
                      padding: theme.space[1],
                      overflow: 'hidden',
                      border: theme.border.base,
                      borderRadius: theme.borderRadius[0],
                      textAlign: 'center'
                    }
                  })}
                >
                  <Text
                    color="medium"
                    css={{
                      fontSize: 10,
                      lineHeight: 1
                    }}
                  >
                    ...
                  </Text>
                </div>
                <CardTooltip
                  displayArrow={false}
                  size="small"
                  {...getPopoverProps({
                    css: {
                      display: 'grid',
                      gap: theme.space[3],
                      gridTemplateColumns: 'minmax(0, 1fr)',
                      maxWidth: 250,
                      wordBreak: 'break-word',
                      overflow: 'hidden'
                    }
                  })}
                >
                  {tooltipContent}
                </CardTooltip>
              </>
            )}
          </Popover>
        </>
      ) : (
        tags.map(([key, value]) => {
          // limit the width of tag values because they can be quite large
          const maxTagValueWidth = 300
          return (
            <Tag
              key={`${key}${value}`}
              tagKey={key}
              tagValue={value}
              valueStyle={{ maxWidth: maxTagValueWidth }}
            />
          )
        })
      )}
    </div>
  )
}

export default React.memo(CharacteristicsTags)
